<template>
  <div>
    <div class="d-flex">
      <v-icon large @click="goBack">mdi-chevron-left</v-icon>

      <h3 class="my-auto">Hey {{ name }} 👋</h3>
      <v-spacer></v-spacer>
      <gamificationCoinVue :amount="coins" :isProfilePage="true" />
    </div>
    <div class="text ml-3 mt-4">
      You're just one step away from scoring amazing discounts! Keep completing
      the tasks listed!
    </div>
    <div class="div mt-3">
      <!-- Content goes here -->
      <div>Need Help?</div>
      <div class="d-flex justify-space-around mt-3">
        <v-card>
          <v-card-text class="d-flex px-lg-16 px-md-2">
            <v-img :src="earn" class="img"></v-img>
            <span class="my-auto ml-1">How to earn</span>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-text class="d-flex px-lg-16 px-md-2">
            <v-img :src="contact" class="img"></v-img>
            <span class="my-auto ml-1">Contact Us</span>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-tabs v-model="tab" class="mt-4" color="orange">
      <v-tab class="text-none">Earn Reward</v-tab>
      <v-tab class="text-none">Redeem Coins</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <!-- Earn Reward Tab -->
      <v-tab-item>
        <v-container fluid style="background-color: #2d8cff0f">
          <!-- <v-row>
            <div class="earn-reward-title">One time tasks for new user</div>
            <v-col
              v-for="(item, index) in earnRewardsData"
              :key="index"
              cols="12"
              sm="12"
              md="12"
            >
              <v-card class="pa-3" style="height: 70px">
                <div class="d-flex justify-space-between">
                  <div class="d-flex align-center justify-start">
                    <div class="card-icon mr-5"><img :src="item.file" /></div>
                    <div class="d-flex align-start justify-start flex-column">
                      <div class="card-title">{{ item.key }}</div>
                      <div class="card-sub-title d-flex">
                        Earn:
                        <span class="card-span">{{ item.coin_reward }}</span>
                        <div>
                          <img
                            src="@/components/gamification/coin_icon.svg"
                            class="ml-1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-card-actions>
                    <v-icon v-if="item.is_completed" color="blue" class="mr-2"
                      >mdi-check-circle</v-icon
                    >
                    <v-radio
                      v-else
                      color="blue"
                      :value="item.key"
                      v-model="item.is_completed"
                    ></v-radio>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
          </v-row> -->
          <v-card class="main-container">
            <div class="d-flex align-center justify-space-between my-5">
              <div>One time tasks for new user</div>
            </div>
            <v-row>
              <v-col
                v-for="(item, index) in earnRewardsData"
                :key="index"
                cols="12"
                sm="12"
                md="12"
              >
                <v-card
                  class="pa-3"
                  style="height: 70px"
                  @click="handleCardClick(index)"
                >
                  <div class="d-flex justify-space-between">
                    <div class="d-flex align-center justify-start">
                      <div class="card-icon mr-5"><img :src="item.file" /></div>
                      <div class="d-flex align-start justify-start flex-column">
                        <div class="card-title">{{ item.key }}</div>
                        <div class="card-sub-title d-flex">
                          Earn:
                          <span class="card-span ml-1">
                            {{ item.coin_reward }}</span
                          >
                          <div>
                            <img
                              src="@/components/gamification/coin_icon.svg"
                              class="ml-1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <v-card-actions>
                      <v-icon v-if="item.is_completed" color="blue" class="mr-2"
                        >mdi-check-circle</v-icon
                      >
                      <v-radio
                        v-else
                        disabled
                        color="blue"
                        :value="item.key"
                        v-model="item.is_completed"
                      ></v-radio>
                    </v-card-actions>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-tab-item>

      <!-- Redeem Coins Tab -->
      <v-tab-item>
        <v-container fluid style="background-color: #2d8cff0f">
          <v-row>
            <v-col
              v-for="(item, index) in redeemCoinsData"
              :key="index"
              cols="12"
              sm="12"
              md="12"
            >
              <v-card class="pa-3" style="height: 70px">
                <div class="d-flex justify-space-between">
                  <div class="d-flex align-center justify-start">
                    <div class="card-icon mr-5">
                      <v-img :src="item.file"></v-img>
                    </div>
                    <div class="d-flex align-start justify-start flex-column">
                      <div class="card-title">{{ item.key }}</div>
                      <div class="card-sub-title d-flex">
                        Starts From:
                        <span class="card-span">{{ item.coin_reward }}</span>
                        <div>
                          <img
                            src="@/components/gamification/coin_icon.svg"
                            class="ml-1"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-card-actions>
                    <v-btn
                      text
                      @click="redirectToUnlockPremiumTrade"
                      v-if="index === 0"
                    >
                      <v-icon> mdi-chevron-right </v-icon>
                    </v-btn>
                    <div v-else class="orange--text mt-3">Coming Soon</div>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <div class="px-3" v-if="tab === 0">
      <createAStreakSectionVue />
    </div>
  </div>
</template>

<script>
import commonFunctions from "../../common/commonFunctions";
import gamificationCoinVue from "@/components/gamification/gamificationCoin.vue";
import Axios from "@/api/BaseAxios.js";
import createAStreakSectionVue from "@/components/gamification/createAStreakSection.vue";
import newAxios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import { mapActions } from "vuex";
export default {
  name: "Gamification",
  components: { gamificationCoinVue, createAStreakSectionVue },
  data() {
    return {
      earn: require("@/assets/images/trending/earn.svg"),
      contact: require("@/assets/images/trending/contact.svg"),
      tab: 0,
      earnRewardsData: [],
      selectedReward: null,
      redeemCoinsData: [],
      name: "",
      coins: "",
    };
  },
  mounted() {
    this.getOneTimeTasks();
    this.getCoinRedeemData();
    this.getCoinData();
  },
  methods: {
    ...mapActions({
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    // claimReward(item) {
    //   console.log(`Claiming reward: ${item.title}`);
    // },
    redirectToUnlockPremiumTrade() {
      this.$router.push({ name: "UnlockPremiumTrade" });
    },
    getCoinData() {
      const onSuccess = (res) => {
        this.name = res.data.data.name;
        this.coins = res.data.data.coins;
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GAMIFICATION_DATA, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    redeemCoin(item) {
      console.log(`Redeeming coin for: ${item.title}`);
    },
    getCoinRedeemData() {
      const onSuccess = (res) => {
        this.redeemCoinsData = res.data.data;
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GET_REDEEM_COIN_DATA, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    getOneTimeTasks() {
      const successHandler = (res) => {
        this.earnRewardsData = res.data.data;
      };
      const errorHandler = () => {};
      Axios.request_GET(
        "/api/one-time-task/detail",
        {},
        {},
        successHandler,
        errorHandler,
        false,
        commonFunctions.IsAuth()
      );
    },
    goBack() {
      this.$router.go(-1); // Navigates to the previous page in history
    },
    handleCardClick(index) {
      if (index === 1) {
        // Redirect to ProfilePage
        this.$router.push({ name: "ProfilePage" });
      } else if (index === 2) {
        // Open add trade dialog
        this.addTrade();
      } else if (index === 3) {
        // Redirect to ExpertPage
        this.$router.push({ name: "ExpertPage" });
      } else if (index === 4) {
        // Redirect to FollowExpertPage
        this.$router.push({ name: "copyTrade" });
      }
    },
    addTrade() {
      // this.trade_form_data.flag = true;
      this.toggleAddTradeModal({
        show: true,
        type: "add",
        filter_by: this.filter_by,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-container {
  padding: 30px;
  height: fit-content;
  border-radius: 14px;
  box-shadow: 2px 8px 14px rgba(49, 93, 146, 0.06);
}
.text {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  color: grey;
}

.div {
  background-color: #fbf9f3;
  border: 2px solid #dcc05c;
  /* Golden color */
  padding: 20px;
  /* Optional: Adjust as needed */
  border-radius: 10px;
}

.img {
  height: 28px;
  width: 28px;
}

.card-icon {
  background-color: #fff7e6;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.card-title {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  text-align: center;
  color: #333333;
}
.card-sub-title {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  text-align: center;
  color: #33333399;
}

.card-span {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 900;
  line-height: 19.12px;
  text-align: center;
  color: black;
}
.earn-reward-title {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 800;
  line-height: 19.12px;
  text-align: left;
  color: #333333;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
